import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import classNames from 'classnames';

import Page from 'components/ui/page';

import './page.less';
import {connect} from "react-redux";
import renderHTML from 'react-render-html';
import GlobalLoaderComponent from "components/ui/global-loader";
import {getPage} from "store/reducers/pages";

import 'react-quill/dist/quill.core.css';
import {Link} from "react-router";

@connect((state) => ({}), {getPage})

export default class PageComponent extends Component {

    state = {
        loading: false,
        page: {},
        key: null,
    };

    async componentWillUpdate(props, state) {
        if (props.params.key !== state.key) {
            await this.setState({
                key: props.params.key,
            });
            this.loadPage();
        }
    }

    componentDidMount() {
        this.forceUpdate();
    }

    async loadPage() {
        this.setState({loading: true});
        const response = await this.props.getPage(this.state.key);
        this.setState({loading: false});
        if (response.isOk) {
            const page = response.payload;
            page.text = page.text.replace(/href="([^"]+)"/g, (full, match) => {
                return 'href="' + match.replace(/\+/g, '%20') + '"';
            });
            this.setState({page});
        } else {
            response.showErrors();
        }
    }

    render() {
        const loader = this.state.loading ? <GlobalLoaderComponent/> : null;

        return (
            <Page pageId="Page" title={this.state.page.title || '...'}>
                {loader}
                <div className="full ql-editor" dangerouslySetInnerHTML={{__html: this.state.page.text || ''}}>
                </div>
            </Page>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/modules/pages/page.js